var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReplaceIcon = function SvgReplaceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "#069BAA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ReplaceIcon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h12v12H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ReplaceIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.313 14c-1.117 0-2.067-.387-2.85-1.162-.784-.775-1.176-1.721-1.176-2.838v-.088l-.45.45a.474.474 0 0 1-.35.138.474.474 0 0 1-.35-.137.474.474 0 0 1-.137-.35c0-.142.046-.259.138-.35l1.3-1.3a.48.48 0 0 1 .7 0l1.3 1.3a.474.474 0 0 1 .137.35.474.474 0 0 1-.137.35.474.474 0 0 1-.35.137.474.474 0 0 1-.35-.137l-.45-.45V10c0 .833.293 1.542.88 2.125.588.583 1.303.875 2.145.875.133 0 .264-.008.393-.025.13-.017.257-.046.382-.088a.596.596 0 0 1 .4.013c.125.05.22.137.287.262a.453.453 0 0 1-.275.65 3.183 3.183 0 0 1-.588.144c-.2.03-.4.044-.6.044Zm-.05-7c-.134 0-.265.008-.394.025a2.02 2.02 0 0 0-.381.087.616.616 0 0 1-.407-.012.548.548 0 0 1-.293-.262.424.424 0 0 1-.02-.382.431.431 0 0 1 .282-.256 3.72 3.72 0 0 1 1.212-.2c1.117 0 2.067.388 2.85 1.162.784.776 1.175 1.721 1.175 2.838v.088l.45-.45a.474.474 0 0 1 .35-.138c.142 0 .259.046.35.137a.474.474 0 0 1 .138.35.474.474 0 0 1-.137.35l-1.3 1.3a.48.48 0 0 1-.7 0l-1.3-1.3a.474.474 0 0 1-.138-.35c0-.141.046-.258.137-.35a.474.474 0 0 1 .35-.137c.142 0 .259.046.35.137l.45.45V10c0-.833-.293-1.542-.88-2.125C11.818 7.292 11.103 7 10.261 7Z",
    fill: "#fff"
  }))));
};
export default SvgReplaceIcon;